export const GoogleMapsAPI = 'AIzaSyCPyNkMQXAaq-JTSJYudvSXdIW9i9rxHp8';